import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import {
  attachAgentSessionToBody,
  buildAgentSessionRequestConfig,
} from "./agentApiSession";

const COMMISSION_SETTINGS_PATH = "/api/agents/me/commission-settings";

function commissionSettingsUrl() {
  return resolveApiUrl(COMMISSION_SETTINGS_PATH);
}

export async function fetchAgentCommissionSettings() {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.get(commissionSettingsUrl(), {
    headers: cfg.headers,
    params: { sessionID: cfg.sid },
    withCredentials: cfg.withCredentials,
    timeout: cfg.timeout,
  });
  return data;
}

export async function saveAgentCommissionSettings(payload) {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.patch(
    commissionSettingsUrl(),
    attachAgentSessionToBody({
      fixed_hotel_commission: payload?.fixed_hotel_commission,
      fixed_flight_commission: payload?.fixed_flight_commission,
      sessionID: cfg.sid,
    }),
    {
      headers: cfg.headers,
      withCredentials: cfg.withCredentials,
      timeout: cfg.timeout,
    }
  );
  return data;
}
